import { ConfirmationForm } from "./Form";
import useConfirmation from "./hooks/useConfirmation";

export const Confirmation = () => {
  const props = useConfirmation();
  return <ConfirmationForm {...props} />;
};

export default Confirmation;
